import * as React from 'react';
import { History } from 'history';

type Props = {
    instructorId: number;
    history: History;

    instructor?: boolean;
};

export default class InstructorTabs extends React.PureComponent<Props, {}> {
    constructor(props: Props) {
        super(props);

        this.instructor = this.instructor.bind(this);
    }

    public render() {
        return <ul className="nav nav-tabs d-print-none">
                <li className="nav-item">
                    <a className={`nav-link${this.props.instructor ? ' active' : ''}`} onClick={this.instructor} href="#">Profile</a>
                </li>
            </ul>
    }

    private instructor(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        e.preventDefault();
        this.props.history.push(`/instructor/${this.props.instructorId}`);
    }
}
